// AUTO GENERATED FILE - Changes WILL be lost.
// vi - used as 'vi' fallback
export const common_fallback = true

export const translations = {}
